export const CUSTOM_KEYS = [
  "provider",
  "best_rate",
  "units_per_case",
  "limit_prod",
  "expensive_product_limit",
  "primary_classification",
  "secondary_classification",
  "rating_notes",
  "producer",
];

export const DEFAULT_DATA = {
  title: "",
  sku: "",
  barcode: "",
  status: "",
  shopifyStatus: "",
  Cin7Id: "",
  averageCost: "",
  brand: "",
  category: "",
  description: "",
  price: "",
  weight: "",
  supplier: "",
  latestPrice: "",
  fixedPrice: "",
  unitsPerCase: "",
  unitOfMeasure: "",
  tags: [],
  price1: "",
  price2: "",
  price3: "",
  calculated1: false,
  calculated2: false,
  calculated3: false,
  markupType1: "",
  markupType2: "",
  markupType3: "",
  usePriceType1: "",
  usePriceType2: "",
  usePriceType3: "",
  markupValue1: "",
  markupValue2: "",
  markupValue3: "",
  continueSelling: false,
  metafields: {
    vintage: "",
    container_deposit_sku: "",
    type: "",
    subtype: "",
    subsubtype: "",
    size: "",
    presentation: "",
    container: "",
    country: "",
    region: "",
    subregion: "",
    abv: "",
    provider: "",
    units_per_case: "",
    primary_classification: [],
    secondary_classification: [],
    rating_notes: {},
    producer: "",
  },
  publications: [],
};